import { Injectable } from '@angular/core'
import { HttpRequest, HttpResponse, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http'
import { Observable, Subject, throwError } from 'rxjs'
import { catchError, filter, finalize, switchMap, take, tap } from 'rxjs/operators'
import { NotificationService } from './notification.service'
import { AuthenticationService } from './authentication.service'
import { Router } from '@angular/router'
import { HelperService } from './helper.service'
import { ENVIRONMENT } from '../app.api'

@Injectable()
export class HttpInterceptorService implements HttpInterceptor {
	private isRefreshingToken = false
	private tokenRefreshedSource = new Subject<any>()
	public tokenRefreshed$ = this.tokenRefreshedSource.asObservable()
	constructor(
		private notificationService: NotificationService,
		private authenticationService: AuthenticationService,
		private router: Router,
		private helper: HelperService
	) { }

	public intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		this.notificationService.initLoading()
		const access_token: string = JSON.parse(localStorage.getItem('access_token'))

		if (this.helper.getUserIp() == null) {
			this.helper.getIpAddress().then((ip: string) => {
				this.helper.setIpAddress(ip)
			})
		}

		const enviroment = ENVIRONMENT;

		request = request.clone({
			setHeaders: {
				'Authorization': `Bearer ${access_token}`,
				'x-forwarded-for': this.helper.getUserIp(),
				'x-environment': enviroment,
				'x-app-version': 'WEB',
				'x-source-from': 'PAINEL'
			}
		})

		if (request.headers && request.headers.has('skipinterceptor')) {
			return next.handle(request)
		}

		return next.handle(request).pipe(
			tap((event: HttpEvent<any>) => {
				if (event instanceof HttpResponse) {
					this.notificationService.stopLoading()
				}
			}), catchError(error => {
				console.log('Request error', error)
				this.notificationService.stopLoading()

				if (error.status === 401) {
					return this.handle401Error(request, next)
				} else if (error.status == 423) {
					this.forceLogout('userIsBlocked')
				} else if (error.status == 419) {
					this.forceLogout('isForcedLogout')
				} else if (error.status == 420) {
					this.notificationService.notify(error.error.message, error.error.statusCode || 400)
				} else if (error.status == 429) {
					this.notificationService.notify('Muitas requisições em pouco tempo, aguarde um pouco!', 429)
				} else if (error.status == 403 && error.error.message == 'Usuário inátivo, procure um administrador!') {
					this.notificationService.notify(error.error.message, 403)
					this.forceLogout('userIsInactive')
				} else {
					if (error.error.message) {
						this.notificationService.notify(error.error.message, error.error.statusCode || 400)
					} else {
						this.notificationService.notify('Erro na requisição', 400)
					}
				}

				return throwError(() => new HttpErrorResponse(error))
			})
		)
	}


	private handle401Error(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		if (!this.isRefreshingToken) {
			console.log('401 error detected. Starting token refresh process...')
			this.isRefreshingToken = true
			const refresh_token: string = JSON.parse(localStorage.getItem('refresh_token'))

			return this.authenticationService.refreshAccess(refresh_token).pipe(
				tap(response => {
					console.log('Token refresh successful:', response)
				}),
				switchMap((response: { access_token: { accessToken: string, refreshToken: string } }) => {
					this.isRefreshingToken = false
					const newAccessToken = response.access_token.accessToken
					this.tokenRefreshedSource.next(newAccessToken)
					console.log('New access token set:', newAccessToken)
					return next.handle(this.addTokenToRequest(request, newAccessToken))
				}),
				catchError(err => {
					console.error('Error during token refresh:', err)
					this.isRefreshingToken = false
					this.forceLogout()
					this.notificationService.stopLoading()
					this.notificationService.notify('Sessão expirada, faça login novamente!', 401)
					return throwError(() => new HttpErrorResponse(err))
				}),
				finalize(() => {
					console.log('Token refresh process completed.')
					this.isRefreshingToken = false
				})
			)
		} else {
			console.log('Token refresh already in progress. Queueing request:', request.url)
			return this.tokenRefreshed$.pipe(
				filter(token => token != null),
				take(1),
				switchMap(token => {
					console.log('Replaying queued request with new token:', request.url, token)
					return next.handle(this.addTokenToRequest(request, token))
				})
			)
		}
	}

	private addTokenToRequest(request: HttpRequest<any>, token: string): HttpRequest<any> {
		return request.clone({ setHeaders: { Authorization: `Bearer ${token}` } })
	}

	private forceLogout(typeLogout?: string) {
		this.helper.setAlreadyConnectedInWebsocket(false)
		this.helper.clearLocalStorage()

		if (typeLogout) {
			localStorage.setItem(typeLogout, 'true')
		}

		this.router.navigate(['/login'])

		if (this.helper.getWebsocket()) {
			this.helper.getWebsocket().disconnect()
		}
	}
}
